import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import IllustrationAssetsRouter from './IllustrationAssetsRouter';
import IllustrationRegionsRouter from './IllustrationRegionsRouter';
import IllustrationAppIdsRouter from './IllustrationAppIdsRouter';

function IllustrationRouter() {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <Redirect to={`${routes.ILLUSTRATIONS}/${routes.ASSETS}`} />
                </Route>
                <Route path={`${path}/${routes.ASSETS}`}>
                    <IllustrationAssetsRouter />
                </Route>
                <Route path={`${path}/${routes.REGIONS}`}>
                    <IllustrationRegionsRouter />
                </Route>
                <Route path={`${path}/${routes.APP_IDS}`}>
                    <IllustrationAppIdsRouter />
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default IllustrationRouter;
